import "../scss/styles.scss";
// Default js file. You can add the plugins in the /vendors folder
(function($) {

"use strict";

var APP = APP || {};

APP.CommonClasses = {
	active: 'is-active',
	open: 'is-open',
	push: 'is-pushed'
};

APP.MyModule = {
	el: {
		exempleLinks: $("a"),
	},
	init: function(){
		this.Log(); // Launch on page load
		this.binds(); // Binds
	},
	binds: function() {
		this.el.exempleLinks.on('click', function(e) {
			APP.MyModule.Log(); // You can also call functions
		});
	},
	Log: function() {
		//console.log('TP1'); 
	}
}

APP.init = function() {
	// List all module
	// APP.MyModule.init();
}

APP.init();

// Show Search bar
var search = false;
$('.custom-search-btn').on('click', function(e){
    e.preventDefault();
    if (!search) {
        $('.berger-search').addClass('open');
        $('.search-input').focus();
    } else if(search) {
        $('#searchform').submit();
    }
    search = true;
});


//$('.selectric select').selectric(); 

// Adding class 'drop-icon' to parent menu-item
$.each($('.menu-item').has('ul.sub-menu'), function(){
	$(this).addClass('drop-icon');
    $(this).find('a').first().addClass('tg-a');
});

// Top navigation hover menu
$('.header-desktop .drop-icon').hover(function(){
	$('.header-desktop').addClass('hover-menu');
}, function(){
	$('.header-desktop').removeClass('hover-menu');
});

// Open mobile menu
$('.toggle-mobile').on('click', function(e){
    e.preventDefault();
    $('.header-mobile').toggleClass('open');
});

// Menu Mobile - Sous-menus
$('body').on('click', '.header-mobile .tg-a', function(e){
    e.preventDefault();
    $(this).parent().toggleClass('open-sub');
    $(this).unbind(e);
});

// On resize, close mobile menu if it reaches dektop width
$(window).on('resize', function(){
    if($('.profile-testimonial .avatar').length) {
        $('.avatar').css('width', $('.avatar').outerHeight() + "px");
    }
    if ($(window).width() > 1024) {
        $('.header-mobile .drop-icon a').removeClass('open-sub');
        $('.header-mobile').removeClass('open');
    }
});


// Mix Finder select options desktop verion
enquire.register("screen and (min-width:1025px)", {
    match : function() {
        $('.single-select').hover(function(){
            $(this).find('.options-array').stop().slideToggle(300);
        });
    },  
    unmatch : function() {
        $('.single-select').hover(function(){
            $(this).find('.options-array').stop().slideToggle(300);
        });
    }
});

// Mix Finder select options mobile verion
enquire.register("screen and (max-width:1024px)", {
    match : function() {
        $('.single-select').on('click', function(){
            $(this).find('.options-array').stop().slideToggle(300);
        });
    },  
    unmatch : function() {
        $('.single-select').on('click', function(){
            $(this).find('.options-array').stop().slideToggle(300);
        });
    }
});

//Contact rep form
if($('#form-contact-rep').length) {
    $('body').on('click', '.contact-rep', function () {
        var name = $(this).text(),
            target = $(this).attr('rel');

        if(name && target) {
            $('.rep-target').text(name);
            $('.hidden_rep_email').find('input').val(target);
            $('#form-contact-rep').addClass('open');

            $('html,body').animate({
                scrollTop: $('#form-contact-rep').offset().top
            }, 1000);
        }
    });
}

// Videos fancy box
$('.fancybox-media').fancybox({
    padding     : 0,
	openEffect  : 'none',
	closeEffect : 'none',
	helpers : {
		media : {}
	}
});

// Potting table fancy box
$('#potting-table').fancybox({
	toolbar  : false,
	smallBtn : true,
	iframe : {
		preload : false
	} 
});

// Product page - Switching tabs
$('.tabs-section .single-tab').on('click', function(){
	var tab = $(this).attr('id');
	switchTab(tab);
});

function switchTab(tab) {
	$('.tabs-section .single-tab').removeClass('selected');
	$('.toggle').css('display','none');
	$('#'+tab).addClass('selected');
	$('.'+tab).css('display', 'block');
}


$('.tabs-section-mobile .single-tab').on('click', function(){
    $('.tabs-content').hide();
    if ($(this).hasClass('selected')) {
        $(this).removeClass('selected');
        $(this).next().hide();
    } else {
        var tabMobile = $(this).attr('id');
        switchTabMobile(tabMobile);
    }
});

function switchTabMobile(tabMobile) {
    $('.tabs-section-mobile .single-tab').removeClass('selected');
    $('#'+tabMobile).addClass('selected');
    $('#'+tabMobile).next().show();
}

$('body').on('click', '.accordion-trigger', function(){
    $(this).parents('.emp-accordion').toggleClass('open');
});


// Template Postlist - Ajax reload content
$('.cat-ajax').on('click', function(e){
	e.preventDefault();
	var category_id = $(this).data('cat');
    var nonce = WPURLS.filter_nonce;
    var _this = this;

    if(category_id == 0) {
        //Let's reload the page to use the pagination properly.
        location.reload();
    } else {
        $.ajax({
            type: "post",
            dataType: "json",
            url: WPURLS.ajaxurl,
            data: {action: "filter_categories", category_id: category_id, nonce: nonce},
            beforeSend: function() {
                $('.cat-ajax').removeClass('selected').removeClass('loading');
                $(_this).addClass('loading');
            },
            success: function (response) {
                $(_this).addClass('selected');
                $(_this).removeClass('loading');
                $(".posts-area").html('');
                $(".posts-area").html(response);
            }
        });
    }
});

// Template Postlist - Ajax reload content
$('.cat-ajax-filter').on('click', function(e){
	e.preventDefault();
	var category_id = $(this).data('cat');
    var duplicated = $('.posts-widget').data('duplicate');
    var nonce = WPURLS.filter_nonce;
    var _this = this;

    if(category_id == 0) {
        //Let's reload the page to use the pagination properly.
        location.reload();
    } else {
        $.ajax({
            type: "post",
            dataType: "json",
            url: WPURLS.ajaxurl,
            data: {action: "filter_categories_v1", category_id: category_id, nonce: nonce, duplicated: duplicated},
            beforeSend: function() {
                $('.cat-ajax-filter').removeClass('selected').removeClass('loading');
                $(_this).addClass('loading');
            },
            success: function (response) {
                $(_this).addClass('selected');
                $(_this).removeClass('loading');
                $(".posts-area").html('');
                $(".posts-area").html(response);
            }
        });
    }
});


    // Template Postlist - Ajax reload content
    $('#searchformpresse').on('submit', function(e){
        e.preventDefault();
        var searchkey = $('#s-press').val();
        var nonce = WPURLS.filter_nonce;
        var _this = this;

        $.ajax({
            type: "post",
            dataType: "json",
            url: WPURLS.ajaxurl,
            data: {action: "search_press", searchkey: searchkey, nonce: nonce},
            beforeSend: function() {
                $(_this).find('#searchsubmit').addClass('loading');
            },
            success: function (response) {
                $(_this).find('#searchsubmit').removeClass('loading');
                $(".posts-area").html('');
                $(".posts-area").html(response);
                $('#s-truc').val('');
                $('html,body').animate({
                    scrollTop: $('.posts-widget').offset().top
                }, 1000);
            }
        });
    });

    // Template Postlist - Ajax reload content
    $('#searchformjob').on('submit', function(e){
        e.preventDefault();
        var searchkey = $('#s-job').val();
        var nonce = WPURLS.filter_nonce;
        var _this = this;

        $.ajax({
            type: "post",
            dataType: "json",
            url: WPURLS.ajaxurl,
            data: {action: "search_job", searchkey: searchkey, nonce: nonce},
            beforeSend: function() {
                $(_this).find('#searchsubmit').addClass('loading');
            },
            success: function (response) {

                //Clean up location and domain filters
                $(_this).find('#searchsubmit').removeClass('loading');
                $('.job-ajax').removeClass('selected').attr('data-domain', '');
                $('.domain-ajax').removeClass('selected').attr('data-cat', '');
                $('.job-all').addClass('selected');

                $(".custom-post-container").html('');
                $(".custom-post-container").html(response);

            }
        });
    });

    // Template Postlist - Ajax reload content
    $('#searchformtruc').on('submit', function(e){
        e.preventDefault();
        var searchkey = $('#s-truc').val();
        var nonce = WPURLS.filter_nonce;
        var _this = this;

        $.ajax({
            type: "post",
            dataType: "json",
            url: WPURLS.ajaxurl,
            data: {action: "search_truc", searchkey: searchkey, nonce: nonce},
            beforeSend: function() {
                $(_this).find('#searchsubmit').addClass('loading');
            },
            success: function (response) {
                $(_this).find('#searchsubmit').removeClass('loading');
                $(".posts-area").html('');
                $(".posts-area").html(response);
                $('#s-truc').val('');
                $('html,body').animate({
                    scrollTop: $('.posts-widget').offset().top
                }, 1000);
            }
        });
    });


    // Template Joblist - Ajax reload content
    $('.job-ajax').on('click', function(e){
        e.preventDefault();
        var category_id = $(this).attr('data-cat');
        var domain_id = $(this).attr('data-domain');
        var nonce = WPURLS.filter_nonce;
        var _this = this;

        $.ajax({
            type: "post",
            dataType: "json",
            url: WPURLS.ajaxurl,
            data: {action: "filter_job_categories", category_id: category_id, domain_id: domain_id, nonce: nonce},
            beforeSend: function() {
                $('.job-ajax').removeClass('selected').removeClass('loading');
                $(_this).addClass('loading');
            },
            success: function (response) {
                $(_this).addClass('selected');
                $(_this).removeClass('loading');
                $('.domain-ajax').attr('data-cat', category_id);
                $(".custom-post-container").html('');
                $(".custom-post-container").html(response);
            }
        });
    });

    // Domain list - Ajax reload content
    $('.domain-ajax').on('click', function(e){
        e.preventDefault();
        var category_id = $(this).attr('data-cat');
        var domain_id = $(this).attr('data-domain');
        var nonce = WPURLS.filter_nonce;
        var _this = this;

        if($(this).hasClass('selected')) {
            domain_id = 0;
        }
        
        $.ajax({
            type: "post",
            dataType: "json",
            url: WPURLS.ajaxurl,
            data: {action: "filter_job_domains", category_id: category_id, domain_id: domain_id, nonce: nonce},
            beforeSend: function() {
                if($(_this).hasClass('selected')) {
                    $(_this).removeClass('selected');
                } else {
                    $('.domain-ajax').removeClass('selected');
                    $(_this).addClass('selected');
                }
            },
            success: function (response) {
                $('.job-ajax').attr('data-domain', domain_id);
                $(".custom-post-container").html('');
                $(".custom-post-container").html(response);
            }
        });
    });

    // Template Presslist - Ajax reload content
    $('.press-ajax').on('click', function(e){
        e.preventDefault();
        var category_id = $(this).data('cat');
        var nonce = WPURLS.filter_nonce;
        var _this = this;

        if(category_id == 0) {
            //Let's reload the page to use the pagination properly.
            location.reload();
        } else {
            $.ajax({
                type: "post",
                dataType: "json",
                url: WPURLS.ajaxurl,
                data: {action: "filter_press_categories", category_id: category_id, nonce: nonce},
                beforeSend: function() {
                    $('.press-ajax').removeClass('selected').removeClass('loading');
                    $(_this).addClass('loading');
                },
                success: function (response) {
                    $(_this).addClass('selected');
                    $(_this).removeClass('loading');
                    $(".custom-post-container").html('');
                    $(".custom-post-container").html(response);

                }
            });
        }
    });

    $('.press-ajax-v1').on('click', function(e){
        e.preventDefault();
        var category_id = $(this).data('cat');
        var duplicated = $('.posts-widget').data('duplicate');
        var nonce = WPURLS.filter_nonce;
        var _this = this;

        if(category_id == 0) {
            //Let's reload the page to use the pagination properly.
            location.reload();
        } else {
            $.ajax({
                type: "post",
                dataType: "json",
                url: WPURLS.ajaxurl,
                data: {action: "filter_press_categories_v1", category_id: category_id, nonce: nonce, duplicated: duplicated},
                beforeSend: function() {
                    $('.press-ajax-v1').removeClass('selected').removeClass('loading');
                    $(_this).addClass('loading');
                },
                success: function (response) {
                    $(_this).addClass('selected');
                    $(_this).removeClass('loading');
                    $(".posts-area").html('');
                    $(".posts-area").html(response);

                }
            });
        }
    });


    $('body').on('click', '.show-form-apply', function(e){
        e.preventDefault();
        $('.form-try').removeClass('opened').hide();
        if(!$('.form-section').hasClass('opened')) {
            $('.form-section').slideDown(500);
            $('.form-section').addClass('opened');
        }
        var targetSendto = $(this).data('sendto');
        var $sendToHidden = $('input[value="cv@berger.ca"]');
        $sendToHidden.attr('value', targetSendto); 
        scrollToForm();
    });

    // Product - Expand form
    var pdfId;
    var pdfLink;
    $('body').on('click', '.show-form', function(e){
        e.preventDefault();
        pdfId = $(this).attr('id');
        pdfLink = $(this).data('url');
        cookie.set( 'brochure_form', pdfLink, {
            expires: 30, // Expires in 999 days
            path: '/'
        });
        var $kio = $('input[value="berger_hidden_unique"]');
        if($kio.val() === undefined) {
            $kio = $('input[berger_tmp="berger_hidden_unique"]')
        }
        $kio.attr('berger_tmp', $kio.val());
        $kio.val(pdfLink);

        if(cookie.get('brochure_form_sent')) {
            window.open(pdfLink, "_blank");
        } else {
            $('.form-try').removeClass('opened').hide();
            if(!$('.form-section').hasClass('opened')) {
                $('.form-section').slideDown(500);
                $('.form-section').addClass('opened');
            }
            scrollToForm();
        }
    });

    $('body').on('click', '.show-try', function(e){
        e.preventDefault();
        $('.form-section, .form-contact').removeClass('opened').hide();
        if(!$('.form-try').hasClass('opened')) {
            $('.form-try').slideDown(500);
            $('.form-try').addClass('opened');
        }
        scrollToForm();
    });

    $('body').on('click', '.show-contact', function(e){
        e.preventDefault();
        $('.form-section, .form-try').removeClass('opened').hide();
        if(!$('.form-contact').hasClass('opened')) {
            $('.form-contact').slideDown(500);
            $('.form-contact').addClass('opened');
        }
        scrollToForm();
    });

    function scrollToForm() {
    	$('html,body').animate({
            scrollTop: $('.scroll-here').offset().top
        }, 1000);
    }

    if($('.profile-testimonial .avatar').length) {
        $('.avatar').css('width', $('.avatar').outerHeight() + "px");
    }

    //Accordion
	if($('.accordeon').length) {
	    $('.accordeon').find('.title').click(function(){
	        var $accordion = $(this).parent();
	        if($accordion.hasClass('open')){
	            $accordion.removeClass('open');
	            $accordion.find('.ac-content').slideUp(400);
	        } else {
	            $accordion.addClass('open');
	            $accordion.find('.ac-content').slideDown(400);
	        }
	    });
	}

    $(document).bind('gform_confirmation_loaded', function(event, formId){
        if(formId == WPURLS.form_id_tp1) {
            cookie.set( 'brochure_form_sent', 1, {
                expires: 30, // Expires in 999 days
                path: '/'
            });
        }
    });


    if($('#reps').length) {

        var latlng = new google.maps.LatLng(24.1751256, -76.7569108); //TP1 address
        var map = new google.maps.Map(document.getElementById('reps'), {
            zoom: 3,
            center: latlng,
            scrollwheel: true
        });

        $('.rep-coor').each(function () {
            var lat = $(this).data('lat'),
                lng = $(this).data('lng'),
                title = $(this).data('rep'),
                latlng = {lat: lat, lng: lng};

            var infowindowplace = new google.maps.InfoWindow({
                content: '<strong>' + title + '</strong>',
                position: latlng,
                pixelOffset: new google.maps.Size(0, -5)
            });
            infowindowplace.open(map);
        });

    }

    if($('#submit-code-geo').length) {
        $("#submit-code-geo").on('submit', function (e) {
            e.preventDefault();
            $("#my-postal-code").blur();
            var postal_code = $('#my-postal-code').val(),
                nonce = $('#submit-codepostal').data("nonce"),
                dataSingle = $('#my-postal-code').attr('data-single'),
                single = false;

            if(dataSingle == 'true'){single = true;}

            //get_rep_by_code(postal_code, nonce);
            get_countries_by_code(postal_code, nonce, single);
        });
    }
    //
    // if($('#submit-code').length) {
    //     $("#submit-code").submit(function (e) {
    //         e.preventDefault();
    //         var postal_code = $('#my-postal-code').val(),
    //             nonce = $('#submit-codepostal').data("nonce"),
    //             geocoder = new google.maps.Geocoder();
    //
    //         geocodeAddress(geocoder, map, postal_code, nonce);
    //     });
    // }

})(jQuery);

// Rep - Reset postal code cookie
$('body').on('click', '#erase-postal a', function(e){
    e.preventDefault();
    cookie.set( 'coordinates', '', {
        expires: -30, // Expires in 999 days
        path: '/'
    });
    location.reload();
});

function get_countries_by_code(postal_code, nonce, single){
    $.ajax({
        type: "post",
        dataType: "json",
        url: WPURLS.ajaxurl, 
        data: {action: "get_country_reps", postal_code: postal_code, nonce: nonce},
        success: function (response) {
            if(response['count'] >= 0 && response['count'] <= 1) {
                //get_rep_by_ajax(postal_code, nonce, response['data'][0]['countryid']);
                get_rep_by_ajax(postal_code, nonce, null, single);
            } else if(response['count'] > 1) {
                set_country_dropdown(response['data'], response['count']);
            }
        }
    })
}

function set_country_dropdown(countryList, count) {
    var lang = $('html').attr('lang'),
        langMessage;

    if (lang === 'fr-FR') {
        langMessage = 'Veuillez sélectionner votre pays:';
    } else if (lang === 'en-US'){
        langMessage = 'Please choose your country:';
    } else {
        langMessage = 'Por favor seleccione un país:';
    }

    var html   = '<div id="code-country-dropdown" name="country" class="single-select-code">';
        html  += '<div class="init"><span class="dynamiq-text" selected value="-1">'+langMessage+'</span><span class="icon icon-angle-down"></span></div>';
        html  += '<ul class="options-array">';
        for (i = 0; i < count; i++) {
            var tempHtml = '<li value='+countryList[i]['countryid']+' class="option">'+countryList[i]['countrylabel']+'</li>';
            html += tempHtml;
        }
        html += '</ul>';
        html += '</div>';
    $('#code-country-list').html(html).show();
    $('#code-country-dropdown li').on('click', function() {
        var postal_code = $('#my-postal-code').val();
        var nonce = $('#submit-codepostal').data("nonce");
        var countryid = $(this).val();
        get_rep_by_ajax(postal_code, nonce, countryid);
    });

    // Mix Finder select options mobile verion
    enquire.register("screen and (min-width:1025px)", {
        match : function() {
            $('.single-select-code').hover(function(){
                $(this).find('.options-array').stop().slideToggle(300);
            });
        },  
        unmatch : function() {
            $('.single-select-code').hover(function(){
                $(this).find('.options-array').stop().slideToggle(300);
            });
        }
    });
    enquire.register("screen and (max-width:1024px)", {
        match : function() {
            $('.single-select-code').on('click', function(){
                $(this).find('.options-array').stop().slideToggle(300);
            });
        },  
        unmatch : function() {
            $('.single-select-code').on('click', function(){
                $(this).find('.options-array').stop().slideToggle(300);
            });
        }
    });
}

function get_rep_by_code(postal_code, nonce){

    var lang = $('html').attr('lang'),
        langMessage;

    if (lang === 'fr-FR') {
        langMessage = 'changer mon code postal';
    } else if (lang === 'en-US'){
        langMessage = 'change my postal code';
    } else {
        langMessage = 'cambiar mi código postal';
    }
    get_rep_by_ajax(postal_code, nonce);
}

function get_rep_by_ajax(postal_code, nonce, countryid, single) {
    var lang = $('html').attr('lang'),
        langMessage;

    if (lang === 'fr-FR') {
        langMessage = 'changer mon code postal';
    } else if (lang === 'en-US'){
        langMessage = 'change my postal code';
    } else {
        langMessage = 'cambiar mi código postal';
    }

    $.ajax({
        type: "post",
        dataType: "json",
        url: WPURLS.ajaxurl,
        data: {action: "set_coord_reps", postal_code: postal_code, nonce: nonce, countryid: countryid},
        success: function (response) {
            var form = response['closest']['img'] + '|' + response['closest']['rep'] + '|' + response['closest']['data'];
            cookie.set( 'coordinates', form, {
                expires: 30, // Expires in 999 days
                path: '/'
            });
            var img_div = '';
            if (response['closest']['img'] !== '') {
                img_div = '<div class="rep-img  sep-right"><img src="'+response['closest']['img']+'"></div>';
            }
            if(single) {
                console.log('is single');
                $('.single-rep').html(
                    '<div class="rep-info sep-left"><div class="sm-title brown">'+response['closest']['rep']+'</div>' + response['closest']['data'] + '</div>' + img_div
                ).show();
            } else {
                $('.my-rep').html(
                    '<div id="erase-postal"><a href="#">'+langMessage+'</a></div>'+
                    img_div +
                    '<div class="rep-info"><div class="sm-title brown">'+response['closest']['rep']+'</div>' + response['closest']['data'] + '</div>'
                ).show();
            }
            $('#submit-code').hide();
        }
    })
}


function geocodeAddress(geocoder, resultsMap, postal_code, nonce) {
    if(postal_code) {
        geocoder.geocode({'address': postal_code}, function(results, status) {
            if (status === google.maps.GeocoderStatus.OK) {

                var lat = results[0].geometry.location.lat();
                var lng = results[0].geometry.location.lng();
                var lang = $('html').attr('lang');
                var langMessage;

                if (lang === 'fr-FR') {
                    langMessage = 'changer mon code postal';
                } else if (lang === 'en-US'){
                    langMessage = 'change my postal code';
                } else {
                    langMessage = 'cambiar mi código postal';
                }

                if(lat && lng) {
                    $.ajax({
                        type: "post",
                        dataType: "json",
                        url: WPURLS.ajaxurl,
                        data: {action: "set_coordinates", lat: lat, lng: lng , nonce: nonce},
                        success: function (response) {
                            var form = response['closest']['img'] + '|' + response['closest']['rep'] + '|' + response['closest']['data'] + '|' + response['closest']['dist'];
                            cookie.set( 'coordinates', form, {
                                expires: 30, // Expires in 999 days
                                path: '/'
                            });
                            var img_div = '';
                            if (response['closest']['img'] !== '') {
                                img_div = '<div class="rep-img  sep-right"><img src="'+response['closest']['img']+'"></div>';
                            }
                            $('.my-rep').html(
                                '<div id="erase-postal"><a href="#">'+langMessage+'</a></div>'+
                                img_div +
                                '<div class="rep-info"><div class="sm-title brown">'+response['closest']['rep']+'</div>' + response['closest']['data'] +
                                '<a class="arrow-white" href="' + response['closest']['team_link'] + '">' + response['closest']['team'] + '</a>' +
                                '</div>'
                            ).show();
                            $('#submit-code').hide();
                        }
                    })
                }

            } else {
                console.log('Geocode was not successful for the following reason: ' + status);
            }
        });
    }
}

// On page load
// Berger mix scroll to results
var resultScroll = $('#taxonomy .scroll-results');
$(window).load(function(){
    if ($('#taxonomy .catalog-products').length){
        $('html,body').animate({
            scrollTop: resultScroll.offset().top - 70
        }, 1000);
    }
});

// Footer - Show extranet links
$('.show-links a').on('click', function(e){
    e.preventDefault();
    $('.show-links').toggleClass('open-links');
});

// Incrémentation des Guides PDF - Thanksgiving
$.ajax({
    url: WPURLS.ajaxurl,
    type: 'get',
    data: {action: 'get_pdf_counter'},
    success: function(response) {
        $('#pdf-numbers').empty().append('<span>'+ response +'</span>');
        $('#pdf-numbers').css('visibility','visible');
        // CountUp Animation
        var numAnim = new CountUp('pdf-numbers', 0, response, 0, 3);
        if (!numAnim.error) {
            numAnim.start();
        }
    }
});
if ($('.counter-container').length) {
    $('.pdf-counter').on('click', function() {
        $.ajax({
            url: WPURLS.ajaxurl,
            type: 'get',
            data: {action: 'update_pdf_counter'},
            success: function(response) {
                // $('#pdf-numbers').empty().append('<span>'+ response +'</span>');
            }
        });
    });
}

// Modify wp store locator scrolldown
if ($('#wpsl-wrap').length){
    $('#wpsl-stores').mCustomScrollbar({
        mouseWheel:{ preventDefault: true }
    });
}

if ($('.dist-rep').length) {
    $('.dist-rep').matchHeight();
}

$('body #wpsl-reset-btn').on('click', function(e) {
    e.preventDefault();
    $('.wpsl-icon-reset').trigger('click');
});


$(document).on({
    "contextmenu": function (e) {
        console.log(e);
        if(typeof e.target.href !== 'undefined' && e.target.href !== null ){
            console.log('target: ' + e.target.href);
            if (e.target.href.toLowerCase().indexOf(".pdf") >= 0) {
                e.preventDefault(); 
            }
        }
    },
});
